import { render } from "./PageHeading.vue?vue&type=template&id=b52b3a76&scoped=true"
import script from "./PageHeading.vue?vue&type=script&lang=js"
export * from "./PageHeading.vue?vue&type=script&lang=js"

import "./PageHeading.vue?vue&type=style&index=0&id=b52b3a76&scoped=true&lan=scss&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52b3a76"]])

export default __exports__